// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { requisitionsRequisitionLineRowStyles } from "@conklin/Overrides/Widgets/Requisitions/RequisitionsRequisitionLineRow";
import { xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

requisitionsRequisitionLineRowStyles.removeLink = {
    icon: {
        iconProps: {},
    },
    css: css`
        &&& {
            ${xScreen("lte", "md")} {
                display: inline-flex;
            }
        }
    `,
};

requisitionsRequisitionLineRowStyles.dateCell = {
    css: css`
        ${xScreen("lte", "md")} {
            align-items: center;
        }
    `,
};

requisitionsRequisitionLineRowStyles.date = {
    size: 14,
    css: css`
        line-height: 22px;
    `,
};
